import { START_PRINT } from "app/actionTypes";
import { RESET_PRINT } from "../actionTypes";

const initialState = {
	isPrintMode: undefined,
};

export default function emailReducer(print = initialState, action) {
	switch (action.type) {
		case START_PRINT:
			return {
				isPrintMode: true,
			};
		case RESET_PRINT:
			return {
				isPrintMode: false,
			};
		default:
			return print;
	}
}
